import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { invoicePreviewQuery as InvoicePreviewQueryData } from './types/invoicePreviewQuery';

type Input = {
  accountId: number;
  planId: string | number | null | undefined;
  currency: string | null | undefined;
};

export const invoicePreviewQuery = gql`
  query invoicePreviewQuery($accountId: Int!, $planId: ID, $currency: String) {
    account(id: $accountId) {
      id
      invoicePreview(planId: $planId, currency: $currency) {
        amountDue
        currency
        id
        invoicedAt
        items {
          amount
          currency
          description
          id
        }
        periodEnd
        startingBalance
        total
      }
    }
  }
`;

export const useInvoicePreview = ({ accountId, planId, currency }: Input) => {
  const queryResults = useQuery<InvoicePreviewQueryData>(invoicePreviewQuery, {
    fetchPolicy: 'network-only',
    skip: !accountId || !planId,
    variables: {
      accountId,
      planId,
      currency,
    },
  });

  return {
    error: queryResults.error
      ? 'There was an issue loading your invoice preview. Please try again'
      : null,
    invoice: queryResults?.data?.account?.invoicePreview,
    isLoading: queryResults.loading,
  };
};
